import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetProvider } from '../asset/asset';
import { CategoriesProvider } from '../categories/categories';
import { Asset } from '../../interfaces/asset.model';
import { LanguageProvider } from '../language/language';
import { AudienceProvider } from '../audience/audience';
import { Audience } from '../../interfaces/audience.model';
import { IndicationProvider } from '../indication/indication';

@Injectable()
export class FilterProvider {

  assets: Asset[];
  selectedAudience: Audience;
  selectedLanguage: string;

  constructor(public http: HttpClient, 
    public categoriesService: CategoriesProvider, 
    public assetService: AssetProvider, 
    public languageService: LanguageProvider, 
    public audienceService: AudienceProvider,
    public indicationService: IndicationProvider) {}

  filterAssets(){
    console.log("FilterProvider::filterAssets()");
    return new Promise<Asset[]>((resolve, reject) => {
      let a = this.getSelectedLang();
      let b = this.getSelectedAudience();
      let c = this.getSelectedIndication();

      Promise.all([a, b, c]).then(data => { 
        const lang = data[0];
        const audience = data[1];
        const indicationId = data[2];
        console.log("FilterProvider::filterAssets(): "+lang+"/"+audience.AudienceName+"/"+indicationId);
        this.assetService.getAssets().then(assets => {
          this.assets = assets.filter(item => item.Language.some(language => language.LanguageCode == lang) 
          && item.Audience.some(a => a.AudienceId == audience.AudienceId)
          && ((indicationId == null) || (indicationId == "") || item.Indication.some(ind => ind.IndicationId == indicationId)));
          this.setNbAssetsByCat();
          resolve(this.assets);
          //asset.Indication.some(indication => indication.IndicationId == indicationId
        });
      });
    });
  }

  getSelectedLang(){
    return this.languageService.getSelectedLang();
  }

  getSelectedAudience(){
    return this.audienceService.getSelectedAudience();
  }

  getSelectedIndication(){
    return this.indicationService.getSelectedIndication();
  }

  setNbAssetsByCat() {
    let filteredCat = this.categoriesService.filterByCategories(null);
    filteredCat.forEach(category => {
      category.nbAssets = this.getAssetsInCategory(category.CategoryId);
      category.totalAssets = category.nbAssets + this.setNbAssetsBySubCat(category.CategoryId);
    });
  }

  setNbAssetsBySubCat(catId) {
    let sum = 0;
    let filteredCat = this.categoriesService.filterByCategories(catId);
    filteredCat.forEach(category => {
      category.nbAssets = this.getAssetsInCategory(category.CategoryId);
      category.totalAssets = category.nbAssets + this.setNbAssetsBySubCat(category.CategoryId);
      sum += category.totalAssets; 
    });
    return sum;
  }

  getAssetsInCategory(selectedCategorie){
    if (this.assets && this.assets.length > 0){
      return this.assets.filter(item => item.CategoryId == selectedCategorie).length;
    }
    return 0;
  }

  filterAssetsByCategory(selectedCategorie) {
    console.log("FilterProvider::filterAssetsByCategory("+selectedCategorie+")");
    if(this.assets && this.assets.length > 0){
      return this.assets.filter(item => item.CategoryId == selectedCategorie);
    }
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/providers/filter/filter.ts